import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map, Observable } from 'rxjs';
import { AdvertiserEntityAdapter, PaginationAdapter } from '@rp/shared/adapters';
import {
  AdvertiserEdit,
  AdvertiserEditRest,
  AdvertiserEntitiesResponse,
  AdvertiserEntityRest,
  AdvertiserEntityRestResponse,
} from '@rp/shared/models';
import { environment } from '@rp/environments';

import { AdvertiserEntitiesProvider } from './advertiser-entities.provider';

@Injectable()
export class HttpAdvertiserEntitiesProvider implements AdvertiserEntitiesProvider {
  private _baseUrl = `${environment.apiConfig.adminApiHost}/admin/users/advertiser-entities`;

  private readonly _httpClient = inject(HttpClient);

  getAdvertiserEntities(params: string): Observable<AdvertiserEntitiesResponse> {
    return this._httpClient.get<AdvertiserEntityRestResponse>(`${this._baseUrl}/?${params}`).pipe(
      map(({ advertiserEntities, ...pagination }) => ({
        advertiserEntities: advertiserEntities.map((advertiserEntity: AdvertiserEntityRest) =>
          AdvertiserEntityAdapter.fromRest(advertiserEntity),
        ),
        ...PaginationAdapter.fromRest(pagination),
      })),
    );
  }

  getAdvertiserEntity(id: number): Observable<AdvertiserEdit> {
    return this._httpClient
      .get<AdvertiserEditRest>(`${this._baseUrl}/${id}/`)
      .pipe(map(advertiser => AdvertiserEntityAdapter.fromEditRest(advertiser)));
  }
}
